export const isValidMobile = (v) => /^[0-9]{10}$/.test((v || "").trim());
export const MOBILE_ERROR = "Enter a valid 10-digit mobile number (digits only)";
